define('util/vector',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.dotMap = exports.dot = void 0;
    /**
     * Vector dot product
     * Requires m1.length == m2.length. No safety.
     */
    function dot(m1, m2) {
        // if (m1.length !== m2.length) throw new Error(`length mismatch ${m1.length} != ${m2.length}`)
        var n = m1.length;
        var out = 0;
        for (var i = 0; i < n; i++) {
            out += m1[i] * m2[i];
        }
        return out;
    }
    exports.dot = dot;
    /**
     * Vector dot product with supplied projection function for the first arg.
     * This function exists to prevent copying data.
     * Requires m1.length == m2.length. No safety.
     */
    function dotMap(m1, m2, proj1) {
        // if (m1.length !== m2.length) throw new Error(`length mismatch ${m1.length} != ${m2.length}`)
        var n = m1.length;
        var out = 0;
        for (var i = 0; i < n; i++) {
            out += proj1(m1[i]) * m2[i];
        }
        return out;
    }
    exports.dotMap = dotMap;
});
//# sourceMappingURL=/assets/javascripts/util/vector.js.map;
